import { createContext, useContext } from "react";
import type { Principal } from "./api";

/**
 * Who is signed in, for the pages that have to decide what to OFFER.
 *
 * The server decides what is allowed; this is only so a page can avoid showing
 * a button whose only outcome is a 403 - which reads as a broken page rather
 * than as something that is not yours. Anything security-shaped must not lean
 * on it: a context value can be anything the browser makes it.
 *
 * Scoped roles are not here on purpose. They belong to a project or a bench and
 * arrive with that object (`project.role`, `bench.role`), computed by the
 * server per request; caching them in a session context is how a UI keeps
 * offering an action after somebody was removed from a group.
 */
export const PrincipalContext = createContext<Principal | null>(null);

export function usePrincipal(): Principal | null {
  return useContext(PrincipalContext);
}

/** Whether the caller is an instance administrator, safe when signed out. */
export function useIsAdmin(): boolean {
  return !!useContext(PrincipalContext)?.is_admin;
}
